exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".valores-td-estilo td {\n    text-align: center !important;\n    font-size: 1.0em;\n}\n\n.ui-button.ui-button-info.ui-state-default, .ui-splitbutton.ui-button-info .ui-button.ui-state-default {\n    background-color: #117df0;\n    border-color: #117df0;\n}\n\n.ui-button.ui-button-info.ui-state-default:hover {\n    background-color: #117df0;\n    border-color: #117df0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/area-restrita/planos/plano/pbdc-beneficio-temporario/pbdc-beneficio-temporario.component.css
// module id = ../../../../../src/app/area-restrita/planos/plano/pbdc-beneficio-temporario/pbdc-beneficio-temporario.component.css
// module chunks = main